import {
  RtFraction,
  RtWithProjectionPeriods,
  RtWithName,
  RtWithValue,
} from "@aprao/common/src/runtypes/common.js";

/**
 * EscalatedAmount can only be added in the cash flow screen.
 *
 * They take a name and an initial value and their installments are uncapped
 * (contrary to other cash flow rows). The typical formula to compute the value
 * to display in the cell is `period value = initial value * portion`
 */
export const RtEscalatedAmount = RtWithValue(RtFraction)
  .merge(RtWithName)
  .merge(RtWithProjectionPeriods);
